import { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import basketball from '../../assets/sports-banners/basketball.webp'
import boxing from '../../assets/sports-banners/boxing.webp'
import race from '../../assets/sports-banners/race.webp'
import rugby from '../../assets/sports-banners/rugby.webp'
import soccer from '../../assets/sports-banners/soccer.webp'
import useCommonEmblaCarousel from '../../hooks/useCommonEmblaCarousel'
import { useBoundStore } from '../../store/store'
import Icon from '../icon'
import { PendingDepositModal } from '../payment-form'
import { StyledLink } from './sliderStyles'

const SportsSlider = () => {
  const [emblaRef] = useCommonEmblaCarousel()
  const { t } = useTranslation('homeV2')
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const pendingDepositModal = useModal(PendingDepositModal)

  const SPORTS_CATEGORIES = [
    {
      img: soccer,
      id: 1,
      label: t('soccer'),
    },
    {
      img: basketball,
      id: 2,
      label: t('basketball'),
    },
    {
      img: boxing,
      id: 10,
      label: t('boxing'),
    },
    {
      img: rugby,
      id: 16,
      label: t('american-football'),
    },
    {
      img: race,
      id: 40,
      label: t('racing'),
    },
  ]

  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container -ml-2.5 lg:-ml-5">
        {[...SPORTS_CATEGORIES, ...SPORTS_CATEGORIES].map((sport, index) => (
          <div
            key={sport.id + index}
            className="pl-2.5 lg:pl-5 flex-[0_0_50%] lg:flex-[0_0_20%]">
            <div className="relative flex-1 bg-white flex p-1 rounded-[25px]">
              <img
                src={sport.img}
                alt={sport.label}
                style={{ aspectRatio: '1' }}
                className="w-full h-full object-cover rounded-[25px]"
              />
              <p className="absolute text-black left-4 top-[17px]">
                {sport.label}
              </p>
              <Link
                to={
                  +pending_bind === 0 || +pending_bind === 2
                    ? undefined
                    : '/sports'
                }
                search={{ id: sport.id.toString() }}>
                <StyledLink
                  onClick={() => {
                    if (+pending_bind === 0 || +pending_bind === 2)
                      pendingDepositModal.show()
                  }}>
                  <Icon id="arrow-right" width="12" height="11" fill="#000" />
                </StyledLink>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SportsSlider
